import { useGetMerchantLocationId } from 'features/common/services';

export const useMerchantLocationId = () => {
    const { getMerchantLocationIdLoaded } = useGetMerchantLocationId();

    return getMerchantLocationIdLoaded();
};
